export function hasAnalyticsConsentFromCookie() {
    const match = document.cookie.match(/(?:^|;\s*)cc_cookie=([^;]*)/);
    if (!match) {
        return false;
    }
    try {
        const cookie = JSON.parse(decodeURIComponent(match[1]));
        return Array.isArray(cookie?.categories) && cookie.categories.includes('analytics');
    } catch {
        return false;
    }
}

export function hasAnalyticsConsent() {
    if (typeof window.CookieConsent?.acceptedCategory === 'function') {
        return window.CookieConsent.acceptedCategory('analytics');
    }
    return hasAnalyticsConsentFromCookie();
}

export function pushGoogleConsentUpdate(analyticsGranted) {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        function gtag() {
            window.dataLayer.push(arguments);
        };

    const state = analyticsGranted ? 'granted' : 'denied';

    gtag('consent', 'update', {
        analytics_storage: state,
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state,
    });

    window.dataLayer.push({
        event: analyticsGranted ? 'consent_analytics_granted' : 'consent_analytics_denied',
        analytics_storage: state,
    });
}
